/**
 * Botão de mostrar/ocultar senha. Vale para qualquer campo:
 * um `.js-olho` alterna o `.js-senha` que estiver no mesmo `.input-group`.
 *
 * Registrado em `site.ts`, então serve as telas do app. A tela de login tem a
 * própria versão porque o markup e as classes de lá são outros.
 */
export function iniciarOlhosDeSenha(escopo: ParentNode = document): void {
    escopo.querySelectorAll<HTMLButtonElement>('.js-olho').forEach(botao => {
        botao.addEventListener('click', () => {
            const campo = botao.closest('.input-group')?.querySelector<HTMLInputElement>('.js-senha');

            if (!campo) return;

            const mostrando = campo.type === 'text';
            campo.type = mostrando ? 'password' : 'text';

            const icone = botao.querySelector('i');
            if (icone) icone.className = mostrando ? 'bi bi-eye' : 'bi bi-eye-slash';

            botao.setAttribute('aria-pressed', String(!mostrando));
            campo.focus();
        });
    });
}
